import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { PersonLeaveService } from 'app/services/models/person-leave.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-person-leave',
  templateUrl: './person-leave.component.html',
  styleUrls: ['./person-leave.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonLeaveComponent implements OnInit {
  @Input() data: { personId: number; row: any };
  personLeaveForm: FormGroup;

  kinds: any[] = [];

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;

  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;

  public basicTP = { hour: 0, minute: 0 };
  public basicTP2 = { hour: 0, minute: 0 };

  statusList: any[] = [
    { id: 1, name: "Onay bekleniyor." },
    { id: 2, name: "Onaylandı" },
    { id: 3, name: "Reddet" }
  ];

  isDayLeave: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private personLeaveService: PersonLeaveService,
    private kindService: KindService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    public formatter: NgbDateParserFormatter,
    private datePipe: DatePipe) { }

  async ngOnInit() {
    this.personLeaveForm = this.fb.group({
      status: [1],
      leaveDay: [1],

      kindId: [null, [Validators.required]],
      personId: this.data.personId
    });
    await this.getAllKinds();
    console.log(this.data);
    if (this.data.row) {

      await this.getByIdPersonLeave(this.data.row.id)
      //this.startFilterDate
    }
  }


  toggleRadio(): void {
    this.isDayLeave = !this.isDayLeave; // Tersine çevir
    console.log('isDayLeave:', this.isDayLeave);
  }

  async getByIdPersonLeave(id) {
    const data = await this.personLeaveService.getByIdPersonLeave(id);
    console.log(data);
    this.personLeaveForm.patchValue({
      kindId: data.kindId,
      status: data.status,
      leaveDay: data.leaveDay
    });

    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);

    this.startFilterDate = startDate.toISOString().split('T')[0];
    this.endFilterDate = endDate.toISOString().split('T')[0]

    // Convert Date objects to NgbDate format (ng-bootstrap uses NgbDate for date pickers)
    this.fromDate = new NgbDate(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
    this.toDate = new NgbDate(endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate());

    if(startDate.getHours() > 0){
      this.isDayLeave = true;
    }

    this.basicTP = {
      hour: startDate.getHours(),
      minute: startDate.getMinutes()
    };

    this.basicTP2 = {
      hour: endDate.getHours(),
      minute: endDate.getMinutes()
    };
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 12);
    console.log(data);
    this.kinds = data.types;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.personLeaveForm.valid) {
      console.log(this.personLeaveForm.value);
      console.log(this.personLeaveForm.value);
      const startDate = new Date(this.startFilterDate);
      const endDate = new Date(this.endFilterDate);
      startDate.setHours(this.basicTP.hour, this.basicTP.minute);
      endDate.setHours(this.basicTP2.hour, this.basicTP2.minute);
      console.log(startDate);
      console.log(endDate);

      const startDateUTC = new Date(Date.UTC(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        startDate.getHours(),
        startDate.getMinutes(),
        startDate.getSeconds()
      ));

      const endDateUTC = new Date(Date.UTC(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        endDate.getHours(),
        endDate.getMinutes(),
        endDate.getSeconds()
      ));

      if (this.data.row) {
        const response = await this.personLeaveService.updatePersonLeave(
          this.data.row.id,
          this.personLeaveForm.value.status,
          this.personLeaveForm.value.leaveDay,
          startDateUTC,
          endDateUTC,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal();
          this.personLeaveService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      } else {
        const response = await this.personLeaveService.createPersonLeave(
          1,
          this.personLeaveForm.value.leaveDay,
          startDateUTC,
          endDateUTC,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal();
          this.personLeaveService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      }
    }
  }



  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && (date.equals(this.fromDate) || date.after(this.fromDate))) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    console.log('Start Date:', startDateFormatted ? startDateFormatted : 'Not selected');
    console.log('End Date:', endDateFormatted ? endDateFormatted : 'Not selected');

    this.startFilterDate = startDateFormatted?.toString() || null;
    this.endFilterDate = endDateFormatted?.toString() || null;

    // Eğer tarihler aynı ise saat seçimi zorunlu hale getir
    if (this.startFilterDate && this.endFilterDate && this.startFilterDate === this.endFilterDate) {
      if (!this.basicTP || !this.basicTP2) {
        console.warn('Aynı tarihler seçildiğinde saat eklenmelidir.');
      }
    }
  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;

    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);

    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  /**
   * Is Inside
   *
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }
}